const locale = {
  table: {
    tableMessages: {
      noData: 'Nenhum registro foi encontrado',
    },
    editColumnMessages: {
      addCommand: 'Adicionar coluna',
      editCommand: 'Alterar coluna',
      deleteCommand: 'Remover coluna',
      commitCommand: 'Aplicar',
      cancelCommand: 'Cancelar',
    },
    groupingPanelMessages: {
      groupByColumn: 'Arraste uma coluna aqui para agrupar',
    },
    filterRowMessages: {
      filterPlaceholder: 'Filtrar...',
    },
    pagingPanelMessages: {
      showAll: 'Mostrar todos',
      rowsPerPage: 'Registros por página:',
      info: '{from} - {to} de {count}',
    },
    sortingMessages: {
      sortingHint: 'Ordenar',
    },
    searchMessages: {
      searchPlaceholder: 'Pesquisar...',
    },
  },
};

export default locale;
